import { type ConnectedProps, connect } from 'react-redux';
import { Backdrop, CircularProgress } from '@mui/material';
import { useNavigation } from 'react-router';
import { type RootState } from '@/state';
import { isAppLoading } from '../state';
import styles from './styles';

type Props = ConnectedProps<typeof connector>;

const Loader = ({ isAppLoading }: Props) => {
  const navigation = useNavigation();
  const isNavigating = Boolean(navigation.location);
  const shouldShowLoader = isNavigating || isAppLoading;

  return (
    shouldShowLoader && (
      <Backdrop sx={styles.backdrop} open={shouldShowLoader}>
        <CircularProgress sx={styles.loader} size={140} thickness={3.5} />
      </Backdrop>
    )
  );
};

const connector = connect((state: RootState) => ({
  isAppLoading: isAppLoading(state),
}));

export default connector(Loader);
